import React, {useEffect, useRef} from 'react';
import Chart from "chart.js/auto";
import {useScores} from "../hooks/useScore";
import "../styles/ChartTest.scss"
import {useParams} from "react-router";


function ChartTest() {
    const chartRef = useRef<HTMLCanvasElement | null>(null);
    const chartInstanceRef = useRef<Chart | null>(null);
    const { category } = useParams();
    const { scores, isLoading } = useScores(category  || "");


    useEffect(() => {

        if (chartRef.current && scores) {
            // Si un graphique existe déjà, on le détruit avant d'en créer un nouveau
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }


            // Création du nouveau graphique
            chartInstanceRef.current = new Chart(chartRef.current, {
                data: {
                    datasets: [{
                        type: 'line',
                        label: 'Moyenne',
                        data: scores.map(score => (score.cumulativeWeightedAverage)),
                        pointRadius: 8,
                        pointHoverRadius: 10,
                        pointStyle:"rect"
                    }, {
                        type: 'line',
                        label: 'Mediane',
                        data: scores.map(score => (score.cumulativeWeightedMedian)),
                        pointRadius: 8,
                        pointHoverRadius: 10,
                    }, {
                        type: 'bar',
                        label: 'Note',
                        data: scores.map(score => (score.normalized_score)),
                    }],
                    labels: scores.map(score => (score.date+"\ncoefficient: "+ score.coefficient))
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        axis: 'x',
                        intersect: false
                    },
                    scales: {
                        y: {
                            min: 0,
                            max: 20,
                            ticks: {
                                stepSize: 2,
                            },
                            title: {
                                display: true,
                                text: 'Note /20'

                            }
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: `Moyenne générale: ${scores?.at(-1)?.cumulativeWeightedAverage}        Mediane: ${scores?.at(-1)?.cumulativeWeightedMedian}`,
                            position: 'top'
                        }
                    }
                }
            });
        }


        return () => {
            // Nettoyage lors du démontage du composant
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [scores]);


    return (
        <canvas id={"chart"} ref={chartRef}></canvas>
    );
}


export default ChartTest;